module.exports = __webpack_public_path__ + "static/media/combat(18).b7e4c776.PNG";